import { memo } from 'react';
import { Box, Image, Loader, ScrollView } from '@betty/moonlight';
import PromoSummary from '../PromoSummary/PromoSummary';
import PromoTerms from '../PromoTerms/PromoTerms';
import usePromo from '../../hooks/usePromo';
import { PromoDetailsEmpty } from '../PromosEmptyStates';
import { Promotion } from '../../state/promos/promos.types';
import ReferrerPromoDetails from './ReferrerPromoDetails';

function PromoDetails({
  id,
}: {
  id: Promotion['slug'] | Promotion['promotionId'];
}) {
  const { promo, promosDataState } = usePromo(id);

  if (promosDataState === 'pending') {
    return <Loader />;
  }

  if (!promo || promosDataState === 'rejected') {
    return <PromoDetailsEmpty />;
  }

  if (promo.contentType === 'Referrer') {
    return <ReferrerPromoDetails promo={promo} />;
  }

  return (
    <ScrollView
      contentContainerStyle={{
        paddingBottom: 'safe-area-inset-bottom',
        width: '100%',
        maxWidth: 600,
        marginHorizontal: 'auto',
      }}
      showsHorizontalScrollIndicator={false}
    >
      <Box>
        <Box flex={1}>
          <Image
            source={promo?.imageUrl}
            width="100%"
            contentFit="cover"
            aspectRatio={2}
            borderRadius={{
              mobile: undefined,
              tablet: 'radius-400',
              desktop: 'radius-400',
            }}
          />
        </Box>
        <Box gap="space-200" padding="space-400">
          <PromoSummary promo={promo} />
          <PromoTerms
            description={promo.longDescription}
            termsAndConditions={promo.termsAndConditions}
          />
        </Box>
      </Box>
    </ScrollView>
  );
}

export default memo(PromoDetails);
